import React from "react";
import styled from "styled-components";
import {
  BASIC_DARK_GRAY,
  BASIC_GRAY_BACKGROUND,
} from "../../../constants/colors";
import { StockGroup } from "../../../ducks/menu";
import { MenuListByCategory } from "./MenuListByCategory";

type Props = {
  stockGroups: StockGroup[];
  selectedLimitedMenus: any;
  onFavorite: (menuId: number, menuCode: string, favorite: boolean) => void;
  onSelectMenu: (args: {
    menuId: number;
    menuName: string;
    amount: number;
    isEarlyBird: boolean;
    optionId?: number;
    optionName?: string;
    orderableQty?: number;
  }) => void;
};

export const StockGroupMenuList: React.FC<Props> = ({
  stockGroups,
  selectedLimitedMenus,
  onFavorite,
  onSelectMenu,
}) => {
  return (
    <>
      {stockGroups.map((group) => (
        <GroupContainer key={group.id}>
          <GroupHeader>
            <GroupName>{group.groupName}</GroupName>
            <StockInfo>
              {group.isSoldOut ? (
                <SoldOut>SOLD OUT</SoldOut>
              ) : group.isUserLimitReached ? (
                <UserLimitReached>注文できません</UserLimitReached>
              ) : (
                <StockRemaining>
                  {/*残り {group.stockRemaining} 個*/}
                </StockRemaining>
              )}
            </StockInfo>
          </GroupHeader>

          {group.categories.map((category) => (
            <MenuListByCategory
              key={category.id}
              categoryRef={undefined}
              category={category}
              menus={category.menus}
              selectedLimitedMenus={selectedLimitedMenus}
              onFavorite={onFavorite}
              onSelectMenu={(args) =>
                onSelectMenu({ ...args, orderableQty: group.orderableQty })
              }
              isSoldOut={group.isSoldOut}
              isUserLimitReached={group.isUserLimitReached}
            />
          ))}
        </GroupContainer>
      ))}
    </>
  );
};

const GroupContainer = styled.div`
  margin-bottom: 32px;
  border-radius: 8px;
  overflow: hidden;
`;

const GroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
`;

const GroupName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${BASIC_DARK_GRAY};
`;

const StockInfo = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

const StockRemaining = styled.span`
  color: #e67e22;
`;

const SoldOut = styled.span`
  color: #999;
  font-weight: 600;
`;

const UserLimitReached = styled.span`
  color: #999;
  font-weight: 600;
`;
